import { useTranslation } from 'react-i18next';

import { i18nNameSpace } from '@shared/consts/i18n.ts';

import styles from './WarningMessage.module.scss';

interface ToastMessageProps {
  message: string;
}

export function WarningMessage({ message }: ToastMessageProps) {
  const { t } = useTranslation(i18nNameSpace.API);

  return (
    <div className={styles.wrapper}>
      <p className={styles.title}>{t('api.warning.common.toastHeaderText')}</p>
      <span className={styles.text}>{message}</span>
    </div>
  );
}
